import React from "react"
import { Container, Row, Col } from "reactstrap"
import "./MykaV2Partnerships.scss"

const MykaV2Partnerships = ({
  partnerHeading,
  partnerIntroBody,
  partnerIntroIcon,
  partnerIntroIconAlt,
  partnerFeatures = [],
}) => {
  return (
    <section className="myka-v2-partnerships">
      <Container>
        {/* Intro row: title first, then image, then body on mobile; 2-col on XL+ */}
        <Row className="myka-v2-partnerships__intro align-items-center">
          {/* Title - shows first on mobile, part of left column on XL+ */}
          <Col xs={12} xl={7} className="order-1 myka-v2-partnerships__title-col">
            {partnerHeading && (
              <h2 className="myka-v2-partnerships__heading">{partnerHeading}</h2>
            )}
          </Col>

          {/* Image - shows second on mobile, right column on XL+ */}
          <Col xs={12} xl={5} className="order-2 myka-v2-partnerships__intro-illustration">
            {partnerIntroIcon?.sourceUrl && (
              <img
                src={partnerIntroIcon.sourceUrl}
                alt={partnerIntroIconAlt || ""}
                className="myka-v2-partnerships__illustration"
                loading="lazy"
              />
            )}
          </Col>

          {/* Body - shows third on mobile, part of left column on XL+ */}
          <Col xs={12} xl={7} className="order-3 myka-v2-partnerships__intro-content">
            {partnerIntroBody && (
              <div
                className="myka-v2-partnerships__intro-body"
                dangerouslySetInnerHTML={{ __html: partnerIntroBody }}
              />
            )}
          </Col>
        </Row>

        {/* Feature cards: 3×2 grid */}
        <Row className="myka-v2-partnerships__features">
          {partnerFeatures.map((feature) => (
            <Col key={feature.title} xs={12} md={6} lg={4} className="myka-v2-partnerships__feature-col">
              <div className="myka-v2-partnerships__feature-card">
                {feature.icon?.sourceUrl && (
                  <div className="myka-v2-partnerships__feature-icon-wrap">
                    <img
                      src={feature.icon.sourceUrl}
                      alt={feature.iconAlt || ""}
                      className="myka-v2-partnerships__feature-icon"
                      loading="lazy"
                    />
                  </div>
                )}
                {feature.title && (
                  <h3 className="myka-v2-partnerships__feature-title">{feature.title}</h3>
                )}
                {feature.body && (
                  <div
                    className="myka-v2-partnerships__feature-body"
                    dangerouslySetInnerHTML={{ __html: feature.body }}
                  />
                )}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default MykaV2Partnerships
